/**
 * Resolve the runtime state of a product after a manual carousel click.
 *
 * The click resolves the whole carousel, so the prefilled state stops being a prefilled state.
 * When the card is selected and has a counter, its value falls back to default/min.
 *
 * The nested `counterSection` is cloned before writing so we never mutate the object that is
 * shared with `productPrefillBaseline`; an in-place write there would leak a positive counter
 * from the current customer into the next lookup.
 */
export function resolveSelectedProductState(item) {
  const updatedItem = { ...item, prefilled: false };

  if (updatedItem.counterSection && updatedItem.selected) {
    updatedItem.counterSection = {
      ...updatedItem.counterSection,
      value: updatedItem.counterSection.value || updatedItem.counterSection.defaultValue || updatedItem.counterSection.min,
    };
  }

  return updatedItem;
}
